import React, { ReactNode } from 'react'
import { Stack, Text } from '@chakra-ui/react'
import { DARK_TEXT_PRIMARY } from 'constants/dark-tokens'
interface IFormViewProps {
  label: string
  value?: string
  children?: ReactNode
  // RallyPD dark surface (e.g. the practice-plan detail drawer). Defaults off so
  // the light Search/Process usages are unaffected.
  isDark?: boolean
}
const ItemProcess = (props: IFormViewProps) => {
  const { label = '', value = '', children, isDark = false } = props

  return (
    <Stack
      direction={{ base: 'column', md: 'row' }}
      spacing={{ base: 1, md: 2 }}
      padding={2}
      alignItems="flex-start"
      width="100%"
      minWidth={0}
      transition="200ms all"
      _hover={{ backgroundColor: isDark ? 'rgba(255,255,255,0.04)' : 'gray.50', transition: '200ms all' }}
    >
      {/* The fixed label column is what a phone has no room for: below `md` the
          value moves under its label instead of being squeezed beside it. */}
      <Text
        fontSize="sm"
        fontWeight={600}
        lineHeight={6}
        color={isDark ? DARK_TEXT_PRIMARY : 'gray.700'}
        minWidth={{ base: 'auto', md: '180px' }}
      >
        {label}
      </Text>
      {children && children}
      {!children && (
        <Text fontSize="md" fontWeight={400} lineHeight={6} color={isDark ? DARK_TEXT_PRIMARY : 'gray.700'}>
          {value}
        </Text>
      )}
    </Stack>
  )
}

export default ItemProcess
